import VerticalPage from "@/components/marketing/VerticalPage";
import { GraduationCap, Wallet, BedDouble, CalendarDays, ShieldCheck, Smartphone } from "lucide-react";

export default function Education() {
  return (
    <VerticalPage
      vertical="Education"
      hero={"Mess. Cafeteria. Canteen. One ID. One wallet."}
      blurb={"Designed for 20,000-student universities and residential colleges — hostel mess subscriptions, day cafeterias, and night canteens all running on a single ledger and a single tap."}
      palette={{
        badge:  "bg-violet-50 text-violet-700",
        iconBg: "bg-violet-50 text-violet-700",
        kpi:    "bg-violet-50 text-violet-900 border border-violet-200",
      }}
      kpis={[
        { value: "20k+",  label: "Students per campus" },
        { value: "3",     label: "Outlets, one wallet" },
        { value: "<1.5s", label: "RFID tap to served" },
        { value: "24/7",  label: "Night canteen ready" },
      ]}
      features={[
        { icon: BedDouble,    title: "Hostel mess subscriptions", desc: "Monthly / quarterly mess plans with leave-day refunds, opt-out windows, and parent-funded auto-renewals." },
        { icon: GraduationCap,title: "Day cafeteria & QSR",        desc: "À-la-carte cafeterias with multi-vendor support, kiosks at the entrance, and queue-busting waiter apps." },
        { icon: Wallet,       title: "One wallet, three outlets",  desc: "Mess subscription, café à-la-carte and night canteen — all draw from a single wallet with separate ledgers." },
        { icon: CalendarDays, title: "Semester planning",          desc: "Plans auto-pause on holidays, exam weeks and vacation breaks. No refund disputes, no manual reconciliation." },
        { icon: ShieldCheck,  title: "Parental visibility",         desc: "Parents see real-time spend, top up the wallet, set per-day caps and get low-balance alerts on WhatsApp + email." },
        { icon: Smartphone,   title: "Student app + ID card",       desc: "Pay by RFID tap, QR scan, or in-app wallet. Same identity across mess, café, library tuck shop, sports canteen." },
      ]}
      useCases={[
        "Hosteller swipes ID at mess: subscription auto-debited, leave-day refund processed at month-end, parent gets the SOA.",
        "Day-scholar buys ₹80 lunch at the cafeteria from their wallet — same wallet that was used for the mess fee.",
        "Final-year project night: night canteen open till 2 AM, orders flow on the same POS, settled the next morning.",
        "Mid-semester: warden pulls a per-block consumption report to negotiate vendor pricing for the next term.",
      ]}
    />
  );
}
